<script setup lang="ts">
import { useConfirm, VIcons } from '@/shared/ui'
import { useModel } from './../model/model'
import { useTranslate } from '@/shared/lib'
import { type ObjectTreeItemType, useObjectTree } from '@/entities/ObjectsTree'

const tree = useObjectTree()
const { removeObject } = useModel()
const { show } = useConfirm()
const { trs } = useTranslate()

/**
 * Функция удаления объекта/объектов
 * пришлось выделенные объекты обрабатывать здесь
 * теряется фокус при подтверждении
 */
const removeHandler = () => {
  let objects: ObjectTreeItemType[] = []

  if (tree.selectObjects.length) {
    objects = [...tree.selectObjects]
  } else {
    objects = [tree.contextObject as ObjectTreeItemType]
  }

  show({
    confirmFunc: () => removeObject(objects),
    title: trs('itf.object_remove'),
  })
}
</script>

<template>
  <div @click="removeHandler"><VIcons type="archive" /> {{ $t('itf.archive') }}</div>
</template>
